export default {
  'Bitcoin & Ethereum': '#E3AE78',
  Leaders: '#B95880',
  Flagship: '#71D9B6',
  Opportunity: '#4571AA',
  Growth: '#B8D38C',
  Challengers: '#D0D047',
}
